import CaretRight from "./SVG/caretRight.svg?react";

const CaretRightIcon = () => {
  return <CaretRight />;
};

export default CaretRightIcon;
